import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3fe54c4e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3fe54c4e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fe54c4e')) {
      api.createRecord('3fe54c4e', component.options)
    } else {
      api.reload('3fe54c4e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3fe54c4e", function () {
      api.rerender('3fe54c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting-phone/components/popup/index.vue"
export default component.exports